import { Heading, Flex } from '@chakra-ui/react'
import { useMediaQuery } from '@chakra-ui/react'
import ImageGallery from 'react-image-gallery'
import React from 'react'
import PageWrapper from '../Common/PageWrapper'
const pic1 = require('../../assets/1.jpg')
const pic2 = require('../../assets/2.jpg')
const pic3 = require('../../assets/3.jpg')
const pic4 = require('../../assets/4.jpg')
const pic5 = require('../../assets/5.jpg')
const pic6 = require('../../assets/6.jpg')
const pic7 = require('../../assets/7.jpg')
const pic1t = require('../../assets/1t.jpg')
const pic2t = require('../../assets/2t.jpg')
const pic3t = require('../../assets/3t.jpg')
const pic4t = require('../../assets/4t.jpg')
const pic5t = require('../../assets/5t.jpg')
const pic6t = require('../../assets/6t.jpg')
const pic7t = require('../../assets/7t.jpg')

const images = [
  {
    original: pic1,
    thumbnail: pic1t,
  },
  {
    original: pic2,
    thumbnail: pic2t,
  },
  {
    original: pic3,
    thumbnail: pic3t,
  },
  {
    original: pic4,
    thumbnail: pic4t,
  },
  {
    original: pic5,
    thumbnail: pic5t,
  },
  {
    original: pic6,
    thumbnail: pic6t,
  },
  {
    original: pic7,
    thumbnail: pic7t,
  },
]

const PicturesPage: React.FC = () => {
  const [isLargerThanSm] = useMediaQuery('(min-width: 58em)')

  return (
    <PageWrapper>
      <Heading mb={12}>Kuvia</Heading>
      <Flex maxW='1200px'>
        <ImageGallery items={images} showThumbnails={isLargerThanSm} />
      </Flex>
    </PageWrapper>
  )
}
export default PicturesPage
